import { useEffect, useRef, useState } from 'react';
import { client } from './axios';
import { FontBase } from './font-base';

const VIDEO_DURATION = 80;
const INACTIVE_DURATION = 60;
const FALLBACK_DURATION = 30;

export function Scoreboard() {
  const [inactiveDuration, setInactiveDuration] = useState<number>(0);
  const [scoreboard, setScoreboard] = useState<any[]>([]);

  const scoreboardIntervalRef = useRef<any>(null);
  const activeSessionIntervalRef = useRef<any>(null);

  const getActiveSession = async () => {
    try {
      const reponse = await client.get('/gothiacup/session', {
        params: {
          track: 0,
        },
      });

      if (reponse.data === '') {
        if (inactiveDuration >= INACTIVE_DURATION + VIDEO_DURATION) {
          setInactiveDuration(FALLBACK_DURATION);
        } else {
          setInactiveDuration(prev => prev + 10);
        }
        return;
      }

      setInactiveDuration(0);
    } catch (error) {
      setInactiveDuration(prev => prev + 10);
    }
  };

  const getScoreboard = async () => {
    try {
      const response = await client.get('/gothiacup/scoreboard');
      setScoreboard(response.data);
    } catch (error) {}
  };

  useEffect(() => {
    const cleanup = () => {
      if (scoreboardIntervalRef.current) {
        clearInterval(scoreboardIntervalRef.current);
        scoreboardIntervalRef.current = null;
      }
    };

    getScoreboard();

    activeSessionIntervalRef.current = setInterval(getActiveSession, 10000);
    scoreboardIntervalRef.current = setInterval(getScoreboard, 10000);

    return cleanup;
  }, []);

  // if (inactiveDuration >= INACTIVE_DURATION || scoreboard.length === 0) {
  //   return (
  //     <video className="w-screen h-screen bg-black" autoPlay loop>
  //       <source src="https://signage-archive.s3.eu-north-1.amazonaws.com/4/uploaded/SEB_Gothia_Loop_2024.mp4" type="video/mp4" />
  //     </video>
  //   );
  // }

  return (
    <div className="w-screen h-screen flex bg-slate-900 flex-col items-start justify-start text-slate-50 ">
      <FontBase />
      <table className="w-full">
        <thead className="bg-slate-900 text-slate-50 h-[9vh] text-[3.5vh]  [&>tr>th]:border-slate-700">
          <tr className="[&>th]:p-2 [&>th]:px-6">
            <th>Rank</th>
            <th>Player</th>
            <th>Time</th>
          </tr>
        </thead>
        <tbody className="">
          {scoreboard.map((score: any, index: number) => (
            <tr
              key={score?.value ?? score.badgeNo}
              className="[&>td]:p-2 [&>td]:px-6 h-[9vh] text-[3.5vh] font-semibold [&>td]:border-slate-600 bg-slate-800  "
            >
              <td className="font-bold w-40 ">
                {`#${index + 1}`}
                {index === 0 && <i className="ri-medal-fill ml-2 text-[gold] "></i>}
                {index === 1 && <i className="ri-medal-fill ml-2 text-[silver] "></i>}
                {index === 2 && <i className="ri-medal-fill ml-2 text-[#CD7F32] "></i>}
              </td>
              <td className="bg-slate-700">{score.name}</td>
              <td>{score.score?.toString()?.substring(0, 8)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

{
  /* <div className="w-screen h-screen flex bg-slate-900 flex-col items-start justify-start text-slate-50 ">
<table className="w-full">
  <thead className="bg-slate-900 text-slate-50 h-[9vh] text-[3.5vh]  [&>tr>th]:border-slate-700">
    <tr className="[&>th]:p-2 [&>th]:px-6">
      <th>Rank</th>
      <th>Player</th>
      <th>Time</th>
    </tr>
  </thead>
  <tbody className="">
    {[...scoreboard].map((score: any, index: number) => (
      <tr key={score.badgeNo} className="[&>td]:p-2 [&>td]:px-6 h-[9vh] text-[3.5vh] font-semibold [&>td]:border-slate-600 bg-slate-800  ">
        <td className="font-bold w-40 ">
          { `#${index + 1}`}
          {index === 0 && <i className="ri-medal-fill ml-2 text-[gold] "></i>}
          {index === 1 && <i className="ri-medal-fill ml-2 text-[silver] "></i>}
          {index === 2 && <i className="ri-medal-fill ml-2 text-[#CD7F32] "></i>}
        </td>
        <td className='bg-slate-700'>{score.name}</td>
        <td>{score.score?.toString()?.substring(0, 8)}</td>
      </tr>
    ))}
  </tbody>
</table>
</div> */
}
